export default __webpack_public_path__ + "static/media/call.21660a6e.svg";